import React from 'react';

export default function(props:any) {

    const fieldTypes:any[] = [];
    gd.const.customFields.list.map((id:string)=>{
        const cf = gd.const.customFields[id];
        fieldTypes.push({
            label: cf.label,
            icon: cf.icon,
            value: cf.id
        });
    });

    return (
        <React.Fragment>
            {fieldTypes.map(ct =>
                <div key={ct.value} className="option" onClick={() => props.onNewCustomField(ct.value)}>
                    <div className={Classes('ico', ct.icon)}/>
                    <div className="label">{ct.label}</div>
                </div>
            )}
        </React.Fragment>
    );
}